import { AddressMySuffix, IAddressMySuffix } from './address-my-suffix.model';
import { ClientDTO, IClientDTO } from './client.model';
import { ILocationMySuffix, LocationMySuffix } from './location-mysuffix.model';
import { ILossPayee } from './loss-payee.model';
import { IPolicyMySuffix } from './policy-my-suffix.model';
export const enum PortType {
    MARINE_CARGO_INSURANCE = 'MCI',
    SELLERS_INTEREST = 'SI',
    BUYERS_INTEREST = 'BI'
}

export const enum MeansOfConveyance {
    VESSEL = 'VESSEL',
    AIR = 'AIR',
    ROAD = 'ROAD',
    RAIL = 'RAIL'
}

export const enum ActiveStatus {
    ACTIVE = 'ACTIVE',
    IN_ACTIVE = 'IN_ACTIVE'
}
export const enum PartyToBeInsuredEnum {
    THE_HOLDER = 'THE_HOLDER',
    CLIENT_ADDRESS = 'CLIENT_ADDRESS',
    LOSS_PAYEE = 'LOSS_PAYEE',
    TO_ORDER = 'TO_ORDER',
    MOVERS_ASSURED = 'MOVERS_ASSURED'
}

export interface ICertificateTradeDetails {
    id?: number;
    clientId?: number;
    product?: string;
    internalReference?: string;
    clientReferenceNumber?: string;
    partyToBeInsured?: string;
    lossPayee?: string;
    activeStatus?: ActiveStatus;
    //for spot client
    partyToBeInsuredName?: string;
    partyToBeInsuredAddressDTO?: IAddressMySuffix;
    partyToBeInsuredIsClient?: boolean;
    placeOfDeliveryAsPerSalesContract?: ILocationMySuffix;
}

export interface IPartyToBeInsured {
    id?: number;
    certificateRequestId?: number;
    name?: string;
    addressDTO?: IAddressMySuffix;
    partyToBeInsuredIsClient?: boolean;
}

export class PartyToBeInsured {
    id?: number;
    certificateRequestId?: number;
    name?: string;
    addressDTO = new AddressMySuffix();
    partyToBeInsuredIsClient?: boolean;
}

export class CertificateTradeDetails {
    id?: number;
    clientObj: any = [];
    certificateClientId?: number;
    product?: string = 'MARINE_CARGO_INSURANCE';
    clientType?: string = '';
    incoterms?: string;
    internalReference?: string;
    clientReferenceNumber?: string;
    partyToBeInsured: string = 'The Holder';
    lossPayee?: string;
    activeStatus?: ActiveStatus = ActiveStatus.ACTIVE;
    partyToBeInsuredName?: string;
    partyToBeInsuredAddressDTO = new AddressMySuffix();
    partyToBeInsuredIsClient?: boolean = true;

    whoIsPartyToBeInsured?: PartyToBeInsuredEnum = PartyToBeInsuredEnum.THE_HOLDER;
    placeOfDeliveryAsPerSalesContract = new LocationMySuffix();
    isDAPChanged?: boolean;
    previousIncoterm?: string;
    previousProduct?: string;
    previousClientType?: string;
    coAssuredPolicyHolder?: IClientDTO = new ClientDTO();
    policyForCoAssured?: IPolicyMySuffix;
    isCertificateForCoAssured?: boolean = false;
    coAssuredId?: number;
    coAssuredPolicyId?: number;
    currentPolicyId: number;
    isCoaasuredDeleted?: boolean;
    policyForFreightForwarder?: any;
    selectedPolicyId?: number;
    clientStaff?: any;
    assuredClientId?: number;
    assuredClientName?: string;
    traderStaffCountryId?: number;
    traderStaffCountryName?: string;
    traderStaffStateId?: number;
    traderStaffStateName?: string;
    assuredAddress?: string;
    specialPolicy?: IPolicyMySuffix;
}

export class CertifiCargoDetails {
    id?: number;
    cargoObj: any = [];
    cargoId?: number;
    cargoDescription?: string;
    cargoValue?: number;
    loadingTypeObj: any = [];
    loadingTypeId?: number;
    subTypeObj: any[];
    subTypeId?: number;
    subTypeName?: string;
    packingTypeObj: any = [];
    packingTypeId?: number;
    currency?: string = 'EUR';
    percentageCover?: string = '100';
    sumInsured?: number;
    finalCalculatedCurrency?: number;
    clientPolicyCurreny?: number;
    activeStatus?: ActiveStatus = ActiveStatus.ACTIVE;
    isImoAvailable?: boolean;
    cargoWeight: number = 0;
    cargoUnit: string;
    enableEsgCarboncare?: boolean = false;
    enablePolicyEsgAwareness?: boolean = false;
    enableEsgComparison?: boolean = false;
    isMocChangeClicked?: boolean = false;
    warOnLand?: boolean = false;
    warCoverSeaVoyage?: string;
    sanctionedCountryTransitDetails?: string;
    buyerDetails?: string;
    unloadingLoadingDetails?: string;
    intermediateCalls?: string;
    lossInWeight?: string;
    vesselOwner?: string;
    shipper?: string;
    supplier?: string;
    charterer?: string;
    seller?: string
    stuffingDate?: string;
    constructor() {
        this.cargoValue = 0;
        this.sumInsured = 0;
        this.cargoUnit = null;
    }

}

export class CertifiShipmentDetails {
    id?: number;
    placeOfOrigin?: string;
    placeOfOriginCountry?: string;
    billingOfLoadingNumber?: string;
    meansOfConveynace?: string = 'VESSEL';
    meansOfConveyanceNumber?: string;
    vesselName?: string;
    portOfLoadingObj: any = [];
    portOfLoadingId?: number;
    portOfDischargeObj: any = [];
    portOfDischargeId?: number;
    finalDestination?: string;
    finalDestinationCountry?: string;
    activeStatus?: ActiveStatus = ActiveStatus.ACTIVE;
    dateOfShipment?: string;
    isImoAvailable?: boolean = false;
    voyageNumber?: string;
    fromStation?: string;
    toStation?: string;
    fromStationCountry?: string;
    toStationCountry?: string;
    isPOOSameAsPOL?: boolean = false;
    isPOFDSameAsPOD?: boolean = false;
    fromStationStateAbbreviation?: string;
    toStationStateAbbreviation?: string;
    placeOfOriginStateAbbreviation?: string;
    placeOfFinalDestinationStateAbbreviation?: string;

    fromStationPlaceId?: string;
    toStationPlaceId?: string;
    placeOfOriginPlaceId?: string;
    placeOfFinalDestinationPlaceId?: string;

    isPolUnknown?: boolean = false;
    polPortCountry?: string;
    polPortCountryIso2?: string;
    polPortCountryPlaceId?: string;
    polStateAbbreviation?: string;

    isPodUnknown?: boolean = false;
    podPortCountry?: string;
    podPortCountryIso2?: string;
    podPortCountryPlaceId?: string;
    podStateAbbreviation?: string;

    portOfLoadingDTO: any;
    portOfDischargeDTO: any;

    shipmentWeight: number = 0;
    shipmentUnit: string;

    enableEsgCarboncare?: boolean = false;
    enablePolicyEsgAwareness?: boolean = false;

    placeOfOriginLocation?: ILocationMySuffix = new LocationMySuffix();
    finalDestinationLocation?: ILocationMySuffix = new LocationMySuffix();

    fromSeaOrRailOrAirportLocation?: ILocationMySuffix = new LocationMySuffix();
    toSeaOrRailOrAirportLocation?: ILocationMySuffix = new LocationMySuffix();
    isVesselUnknown: boolean;
    isFirstClassVessel: boolean;
    isVesselNameOrImoMandatory: boolean;
    displayImoNumber: string;
    displayVesselName: string;
    placeOfOriginFreeText: string;
    placeOfFinalDestinationFreeText: string;
    isLocationAcknowledged: boolean = false;

    constructor() {
        this.shipmentUnit = null;
    }
}


export class WarCertificateAdditionalInfo {
    cargoLoadingType?: string;
    warOnLand?: boolean = true;
    warCoverSeaVoyage?: string;
    warCoverSeaVoyageSet:any;
    sanctionedCountryTransitDetails?: string;
    buyerDetails?: string;
    unloadingLoadingDetails?: string;
    intermediateCalls?: string;
    lossInWeight?: boolean = true;
    vesselOwner?: string;
    shipper?: string;
    supplier?: string;
    charterer?: string;
    seller?: string
    stuffingDate?: string;
}

export class CertificateRequestDto {
    id?: number;
    clientId?: number;
    tradeDetailsDTO?: CertificateTradeDetails;
    cargoDetailsDTO?: CertifiCargoDetails;
    shipmentDetailsDTO?: CertifiShipmentDetails;
    warCertificateAdditionalInfoDto?: WarCertificateAdditionalInfo;
    activeStatus?: ActiveStatus = ActiveStatus.ACTIVE;
    revisedFromCertificateRequestId?: number;
    certificateRequestNumber?; string;
    lossPayeeDTO?: ILossPayee;
    isRequestedToRevise?: boolean;
    requestRevisionId?: number;
    spotClientEmailId?: string;
    captcha?: any;
    policyId?: any;
    isFirstClassVessel?: boolean;
    certificateNumber?: any;
    createdByFavouriteRequestId: any;
    isRequestCreatedByFavourite: boolean;
    // previousDeclarationRequestId?: any;
    politicalRiskInvolved?: boolean;
    warPolicyId?: any;

}
